export const LANGUAGE = '@Transfer:language'
